const routes = [
  {
    path: '',
    name: 'admin',
    meta: {
      hide: true,
      requiresAuth: true,
    },
    component: () => import('@/modules/admin/agent/layout/MainLayout.vue'),
    children: [
      // {
      //   path: '',
      //   name: 'layout',
      //   // component: () =>
      //   //   import('@/modules/admin/modules/home/views/HomeView.vue'),
      //   children: [
      {
        path: 'home',
        name: 'home.layout',
        // component: () =>
        //   import('@/modules/admin/modules/home/views/HomeView.vue'),
        children: [
          {
            path: '',
            name: 'home',
            component: () =>
              import('@/modules/admin/agent/modules/home/views/HomeView.vue'),
          },
          {
            path: 'process',
            name: 'process.details',
            component: () =>
              import(
                '@/modules/admin/agent/modules/home/modules/process/views/ProcessDetails.vue'
              ),
          },
          {
            path: 'finance',
            name: 'finance.details',
            component: () =>
              import(
                '@/modules/admin/agent/modules/home/modules/finance/views/FinanceDetails.vue'
              ),
          },
        ],
      },
      {
        path: 'process',
        name: 'process',
        component: () =>
          import('@/modules/admin/agent/modules/process/views/ProcessView.vue'),
      },
      {
        path: 'report',
        name: 'report',
        component: () =>
          import('@/modules/admin/agent/modules/reports/views/ReportView.vue'),
      },
      //   ],
      // },
    ],
  },
  // {
  //   path: 'verify-email',
  //   name: 'verify.email',
  //   component: () => import('@/modules/admin/views/verify/VerifyEmail.vue'),
  //   meta: {
  //     hide: true,
  //     requiresAuth: true,
  //   },
  // },
];

export default routes;
